export default __webpack_public_path__ + "static/sponsor-graphic-e4e467662db6f92e7117cd156a1fc99a.png";